import {useMemo} from 'react'
import dayjs from 'dayjs'
import 'dayjs/locale/it'
import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {capitalize} from '@/utilities/helpers'
import {useTranslation} from '@/translations/i18n'
import {formatDate} from '@/dayjs'
interface InputSelectLastYearMonthProps {
    onChange: (value: string) => void
    value: string
    label?: string
    errorMessage?: string
    disabled?: boolean
    onClear?: () => void
}
const today = dayjs().locale('it')
export const InputSelectLastYearMonth = ({
    onChange,
    value,
    label,
    errorMessage,
    disabled,
    onClear
}: InputSelectLastYearMonthProps) => {
    const {t} = useTranslation()

    const monthOptions = useMemo(() => {
        const options: [string, string][] = []

        // Generate options from current month back to 12 months ago
        for (let i = 0; i < 12; i++) {
            const monthDate = today.subtract(i, 'month')
            const endOfMonth = monthDate.endOf('month')
            const label = monthDate.format('MMMM YYYY')

            options.push([formatDate(endOfMonth.toISOString(), 'YYYY-MM-DD'), capitalize(label)])
        }

        return options
    }, [])

    return (
        <InputSelect
            label={label || t('commons:month')}
            placeholder={t('commons:select_month')}
            value={value}
            onChange={onChange}
            optionsEntries={monthOptions}
            errorMessage={errorMessage}
            disabled={disabled}
            onClear={onClear}
        />
    )
}
